// @ts-check

<script setup>
import BaseIcon from '@/components/base/BaseIcon.vue'
import CardDialog from '@/components/dialogs/CardDialog.vue'
import { computed, inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

const emit = defineEmits(['close'])

defineOptions({
  name: 'MobilePlatformVersionDialog'
})

const { t } = useI18n()
const store = useStore()

const isAndroid = inject('isAndroid', false)
const textSuffix = computed(() => (isAndroid.value ? 'android' : 'ios'))

const minimumAllowedAndroidVersion = computed(
  () => store.getters['mobileData/minimumAllowedAndroidVersion']
)

const minimumAllowedIosVersion = computed(
  () => store.getters['mobileData/minimumAllowedIosVersion']
)

const mobileWrapperPlatformVersion = computed(
  () => store.getters['mobileData/mobileWrapperPlatformVersion']
)

const requiredVersion = computed(() =>
  isAndroid.value
    ? minimumAllowedAndroidVersion.value
    : minimumAllowedIosVersion.value
)
</script>

<template>
  <CardDialog fullscreen hide-primary-action close-on-back stacked-actions>
    <div class="flex h-full justify-center">
      <div class="place-self-center">
        <BaseIcon
          illustration
          name="alert"
          custom-size
          class="mb-4 h-16 text-transparent"
        />
        <h1 class="mb-4 font-bold">
          {{ t(`mobile.platform_version_dialog.title_${textSuffix}`) }}
        </h1>
        <p class="mb-4">
          {{ t(`mobile.platform_version_dialog.description_1_${textSuffix}`) }}
        </p>
        <p class="mb-4">
          {{ t(`mobile.platform_version_dialog.description_2_${textSuffix}`) }}
        </p>
        <p class="mb-4">
          {{ t(`mobile.platform_version_dialog.description_3_${textSuffix}`) }}
        </p>
        <p class="mb-1">
          <span class="font-bold">
            {{
              t(
                `mobile.platform_version_dialog.version_information_current_${textSuffix}`
              )
            }}
          </span>
          {{ mobileWrapperPlatformVersion }}
        </p>
        <p class="mb-4">
          <span class="font-bold">
            {{
              t(
                `mobile.platform_version_dialog.version_requirement_1_${textSuffix}`
              )
            }}
          </span>
          {{
            t(
              `mobile.platform_version_dialog.version_requirement_2_${textSuffix}`,
              { requiredVersion }
            )
          }}
        </p>
      </div>
    </div>
    <template #cancel>
      <SecondaryButton @click.stop="emit('close')">
        {{ t('mobile.platform_version_dialog.close') }}
      </SecondaryButton>
    </template>
  </CardDialog>
</template>
